export enum DelegatedAuthStyle {
    automaticRedirection = 0,
    manualRedirectionWithHiddenForm = 1,
    manualRedirectionWithVisibleForm = 2,
}
